import { render, staticRenderFns } from "./BugCommit.vue?vue&type=template&id=21a9f994&scoped=true&"
import script from "./BugCommit.vue?vue&type=script&lang=js&"
export * from "./BugCommit.vue?vue&type=script&lang=js&"
import style0 from "./BugCommit.vue?vue&type=style&index=0&id=21a9f994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9f994",
  null
  
)

export default component.exports